import { useState, useEffect } from 'react';
import { getFormById, getAllForms } from './forms';
import AuthGuard from './components/AuthGuard';
import './App.css';


function App() {
  const [formId, setFormId] = useState('');
  const [currentForm, setCurrentForm] = useState(null);
  const [availableForms, setAvailableForms] = useState([]);

  useEffect(() => {
    // Obter lista de formulários disponíveis
    setAvailableForms(getAllForms());
    
    // Tentar obter o formId da URL
    const urlParams = new URLSearchParams(window.location.search);
    const idFromUrl = urlParams.get('form');
    
    if (idFromUrl) {
      setFormId(idFromUrl);
      loadForm(idFromUrl);
    } else {
      // Se não houver ID na URL, mostrar seletor de formulário
      setFormId('');
    }
  }, []);

  const loadForm = (id) => {
    const formConfig = getFormById(id);
    if (formConfig) {
      setCurrentForm(formConfig);
      setFormId(id);
    } else {
      console.error(`Formulário com ID "${id}" não encontrado`);
      setCurrentForm(null);
    }
  };

  const handleFormChange = (e) => {
    const selectedId = e.target.value;
    if (selectedId) {
      loadForm(selectedId);
      // Atualizar URL
      const url = new URL(window.location);
      url.searchParams.set('form', selectedId);
      window.history.pushState({}, '', url);
    } else {
      setCurrentForm(null);
      setFormId('');
      // Limpar URL
      const url = new URL(window.location);
      url.searchParams.delete('form');
      window.history.pushState({}, '', url);
    }
  };

  // Componente interno que renderiza o conteúdo da aplicação
  const AppContent = ({ authToken }) => {
    // Se não há formId, mostrar seletor
    if (!formId) {
      return (
        <div className="app-container">
          <div className="form-wrapper">
            <h1 className="form-title">Seletor de Formulários</h1>
            <p className="form-subtitle">Escolha qual formulário você deseja usar</p>
            
            <div className="form-group">
              <label className="form-label">Selecione o Formulário</label>
              <select 
                value={formId} 
                onChange={handleFormChange}
                className="form-select"
              >
                <option value="">Escolha um formulário...</option>
                {availableForms.map((id) => {
                  const config = getFormById(id);
                  return (
                    <option key={id} value={id}>
                      {config.title}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
        </div>
      );
    }

    // Se há formId mas não encontrou o formulário
    if (!currentForm) {
      return (
        <div className="app-container">
          <div className="form-wrapper">
            <h1 className="form-title">Erro</h1>
            <p className="form-subtitle">Formulário não encontrado</p>
            <button 
              onClick={() => setFormId('')}
              className="submit-button"
            >
              Voltar ao Seletor
            </button>
          </div>
        </div>
      );
    }

    // Renderizar o formulário selecionado
    const FormComponent = currentForm.component;

    return (
      <div className="app-container">
        <div className="form-wrapper">
          <div className="form-header">
            <h1 className="form-title">{currentForm.title}</h1>
            <p className="form-subtitle">{currentForm.subtitle}</p>
            <button 
              onClick={() => setFormId('')}
              className="back-button"
            >
              ← Voltar ao Seletor
            </button>
          </div>
          <FormComponent authToken={authToken} />
        </div>
      </div>
    );
  };

  // Envolver todo o conteúdo com AuthGuard
  return (
    <AuthGuard>
      <AppContent />
    </AuthGuard>
  );
}

export default App;